module.exports = __webpack_public_path__ + "img/mapOfficeActive.f701f45.svg";